import { motion } from "framer-motion";
import { SectionHead } from "@/components/site/SectionHead";
import { PhotoSlot } from "@/components/site/PhotoSlot";
import { QuoteButton } from "@/components/site/Cta";
import { Reveal } from "@/components/site/Reveal";
import { INSTALL_POINTS, PHOTOS } from "@/content/site";

export const Installation = ({ index = "06" }) => (
  <section id="installation" data-testid="installation-section" className="relative bg-[#08090a] py-24 sm:py-32">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12">
      <div className="grid gap-10 lg:grid-cols-12 lg:items-end">
        <SectionHead className="lg:col-span-7" index={index} eyebrow="Solar Installation" lines={["Your energy.", "Your home.", "Your future."]} />
        <Reveal className="lg:col-span-5">
          <p className="text-base md:text-lg leading-relaxed text-zinc-300">
            Solar Energy Doc provides professional solar installation throughout Texas — designed around your property, installed by certified technicians and tested before handoff.
          </p>
          <div className="mt-8"><QuoteButton service="Solar Installation" testId="installation-cta">Request a Free Consultation</QuoteButton></div>
        </Reveal>
      </div>
      <div className="mt-16 grid grid-cols-1 gap-4 lg:grid-cols-12">
        <Reveal className="lg:col-span-5 lg:self-center">
          <PhotoSlot src={PHOTOS.installation} alt="Completed residential solar panel installation on a Texas home" label="Completed installation" className="w-full aspect-[16/9] rounded-2xl border border-white/10" testId="installation-photo" />
        </Reveal>
        <ul className="min-w-0 lg:col-span-7 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-white/10 bg-white/10" data-testid="installation-points">
          {INSTALL_POINTS.map((p, i) => (
            <motion.li key={p} initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true, amount: 0.1 }} transition={{ duration: 0.6, delay: i * 0.05 }}
              className="group relative bg-[#0d0f12] p-5 sm:p-7 transition-colors duration-500 hover:bg-[#14171c]">
              <span className="font-mono text-[11px] text-amber-400">{String(i + 1).padStart(2, "0")}</span>
              <p className="mt-6 sm:mt-10 font-display text-[13px] sm:text-base uppercase text-white [overflow-wrap:anywhere]">{p}</p>
              <span className="absolute bottom-0 left-0 h-px w-0 bg-amber-400 transition-[width] duration-700 group-hover:w-full" />
            </motion.li>
          ))}
        </ul>
      </div>
    </div>
  </section>
);
